import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type ClearSeonCooldownPayload = {
  user_id: string;
};

export type ClearSeonCooldownResponse = {
  success?: boolean;
  cleared?: boolean;
  message?: string;
} | null;

const clearSeonCooldown = async ({
  user_id,
}: ClearSeonCooldownPayload): Promise<ClearSeonCooldownResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.CLEAR_SEON_COOLDOWN.replace("{user_id}", user_id),
  );

  return response?.data ?? null;
};

export const usePostClearSeonCooldown = () =>
  useMutation<ClearSeonCooldownResponse, Error, ClearSeonCooldownPayload>({
    mutationKey: ["clearSeonCooldown"],
    mutationFn: clearSeonCooldown,
  });
